import { IFRResource } from "app/resources/ifrresource";
import { DatePickerComponent } from 'app/calendar/ng2-datepicker.component';

export class NewsletterScheduleResource{
		active: boolean;
		errorCode: number;
		errorMessage: string;
		interval: number;
		rid: number;
		startDate: string;
		previouslyStartDate: string;
	 	firstSend: boolean;
		userEmail: string;
}
